import { getAppInstance, getInternalProfileEnabled } from '/@/store/session/selectors';

export const getFieldTrialsNetworkEnabled = (state) => {
    const appInstance = getAppInstance(state);
    return getInternalProfileEnabled(state) && appInstance.enableFieldTrialNetwork;
};
